import React, {useCallback, useEffect, useState} from 'react';
import Pagination from 'react-js-pagination';
import {useMutation} from '@tanstack/react-query';
import {getBoard, updatePassword} from '../library/api';
import moment from 'moment';


export const handleFilesName = (url) => {
// URL 에서 쿼리 문자열 제거

    if (url === '') return '';

    const cleanedUrl = url?.split('?')[0];
    const type = cleanedUrl?.split('.')[cleanedUrl?.split('.').length - 1];

    // 경로에서 파일 이름만 추출
    let fileName = cleanedUrl?.substring(cleanedUrl?.lastIndexOf('/') + 1);
    // 확장자 앞에 있는 _문자열_ 패턴을 제거
    const regex = new RegExp(`_[^_]+_\\.${type}$`);

    fileName = fileName?.replace(regex, `.${type}`);
    return fileName;
};
const Notice = () => {
    const [totalCount, setTotalCount] = useState(0);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(1000);
    const [selectedBoard, setSelectedBoard] = useState(false);
    const [searchTxt, setSearchTxt] = useState('');
    const [searchValue, setSearchValue] = useState('');

    // 퍄트너스 게시글/공지사항 가져오기
    const {mutate: getBoardMutate, data: getBoardData} = useMutation({
        mutationFn: getBoard,
        mutationKey: ['getBoard'],
        onSuccess: data => {
            setTotalCount(data.totalCount);
            setLimit(10 - data.noticeList.length);

        },
        onError: error => {
            if (error.response.data.code !== 401) {
                alert(error.response.data.message);
            }
            throw error;
        }
    });


    useEffect(() => {
        if (selectedBoard) return;

        const items = {
            board_seq: null,
            page: page,
            limit: limit,
            searchTxt: searchTxt
        };
        getBoardMutate(items);
    }, [selectedBoard, page, searchTxt, limit]);

    const handleDownloadFiles = async (fileUrl, fileName) => {
        try {
            const parseUrl = fileUrl.replace('https://bucket-9uc28v.s3.ap-northeast-2.amazonaws.com/', '');

            const proxyUrl = 'https://variable-peafowl-ilsaram-0ee58bff.koyeb.app';
            const response = await fetch(`${proxyUrl}/${fileUrl}`, {
                method: 'GET',
                headers: {
                    // 'Content-Type': 'application/octet-stream',  // 또는 해당 MIME 타입 설정
                    // 'Content-Type': 'application/vnd.ms-excel'
                }
            });
            if (!response.ok) {
                throw new Error('파일 다운로드 실패');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);  // 메모리 해제

        } catch (error) {
            console.error('다운로드 중 오류 발생:', error);
        }
    };

    // html 변경
    const createMarkup = (content) => {
        const formattedText = content?.replace(/\n/g, '<br />');
        return {__html: formattedText};
    };
    const noticeContent = (content) => {
        return (
            <>
                <div className="border-b-2 border-teal-500 mb-3"></div>
                <h2 className="text-lg font-bold px-2">{content?.subject}</h2>
                <div className="border-b border-gray-300 mt-3 mb-3"></div>
                <p className="text-sm text-gray-500 px-2">작성일
                    : {moment.utc(content?.crt_dt).format('YYYY.MM.DD')}</p>
                <div className="border-b border-gray-300 mt-3 mb-3"></div>
                <p className="px-2 min-h-[340px]"
                   dangerouslySetInnerHTML={createMarkup(content?.content)}></p>
                {
                    content?.attachment_01 !== null &&
                    (<>
                            <div className="border-t  border-gray-300 mt-3 mb-3">
                            </div>
                            <div className="flex">
                                <p
                                    className="text-sm text-gray-500 pl-2">첨부파일
                                    : </p>{<div className="pl-2 flex gap-[4px] flex-col">
                                {
                                    content?.attachment_01 !== null && <h5
                                        className="text-sm text-gray-500 cursor-pointer"
                                        onClick={async (event) => {
                                            event.preventDefault();
                                            await handleDownloadFiles(content?.attachment_01, handleFilesName(content?.attachment_01));
                                        }}>{handleFilesName(content?.attachment_01)}</h5>
                                }

                                {
                                    content?.attachment_02 !== null && <h5
                                        className="text-sm text-gray-500 cursor-pointer"
                                        onClick={async (event) => {
                                            event.preventDefault();
                                            await handleDownloadFiles(content?.attachment_02, handleFilesName(content?.attachment_02));
                                        }}>{handleFilesName(content?.attachment_02)}</h5>
                                }
                                {
                                    content?.attachment_03 !== null && <h5
                                        className="text-sm text-gray-500 cursor-pointer"
                                        onClick={async (event) => {
                                            event.preventDefault();
                                            await handleDownloadFiles(content?.attachment_03, handleFilesName(content?.attachment_03));
                                        }}>{handleFilesName(content?.attachment_03)}</h5>
                                }
                                {
                                    content?.attachment_04 !== null && <h5
                                        className="text-sm text-gray-500 cursor-pointer"
                                        onClick={async (event) => {
                                            event.preventDefault();
                                            await handleDownloadFiles(content?.attachment_04, handleFilesName(content?.attachment_04));
                                        }}>{handleFilesName(content?.attachment_04)}</h5>
                                }
                                {
                                    content?.attachment_05 !== null && <h5
                                        className="text-sm text-gray-500 cursor-pointer"
                                        onClick={async (event) => {
                                            event.preventDefault();
                                            await handleDownloadFiles(content?.attachment_05, handleFilesName(content?.attachment_05));
                                        }}>{handleFilesName(content?.attachment_05)}</h5>
                                }

                            </div>}</div>
                        </>
                    )
                }
                <div className="border-b-2 border-gray-300 mt-3 mb-[60px]"></div>
                <div className="text-center">
                    <button onClick={event => setSelectedBoard(false)}
                            className="bg-teal-500 text-white sm:px-[66px] px-8 sm:py-4 py-2 rounded-[30px] hover:bg-teal-600 transition duration-300 text-lg font-extrabold sm:text-base">목록보기
                    </button>
                </div>
            </>
        );
    };
    return (
        <main className="flex-grow container mx-auto px-4 py-16">
            <div className="max-w-4xl mx-auto">
                <h1 className="sm:text-3xl text-2xl font-bold mb-6">공지사항</h1>
                {
                    selectedBoard ? getBoardData?.list?.length !== 0 ? noticeContent(getBoardData?.list[0]) : noticeContent(getBoardData?.noticeList[0])
                        : <>
                            <div className="max-w-6xl mx-auto">
                                <div className="bg-white border-t-2 border-teal-500">
                                    <table className="w-full table-auto hidden sm:table">
                                        <thead>
                                        <tr className="border-b border-gray-200">
                                            <th className="py-5 px-4 text-center text-sm font-bold text-[#333] whitespace-nowrap"
                                                width={100}>NO
                                            </th>
                                            <th className="py-5 px-4 text-center text-sm font-bold text-[#333]  whitespace-nowrap">제목</th>
                                            <th className="py-5 px-4 text-center text-sm font-bold text-[#333] whitespace-nowrap"
                                                width={150}>작성일
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody className="text-gray-600 text-sm">
                                        {
                                            getBoardData && getBoardData?.totalCount > 0 ?
                                                <>
                                                    {
                                                        getBoardData?.noticeList?.map((item, i) => (
                                                            (
                                                                <tr className="border-b border-gray-200 cursor-pointer hover:bg-[#3FBAB11F]"
                                                                    key={item.board_seq}
                                                                    onClick={event => {
                                                                        event.preventDefault();
                                                                        setSelectedBoard(true);
                                                                        const items = {
                                                                            board_seq: item.board_seq,
                                                                            page: 1,
                                                                            limit: 10,
                                                                            searchTxt: ''
                                                                        };
                                                                        getBoardMutate(items);
                                                                    }}>
                                                                    <td className="py-5 text-center  whitespace-break-spaces">공지</td>
                                                                    <td className="py-5 px-4 text-left  whitespace-break-spaces">{item.subject}
                                                                    </td>
                                                                    <td className="py-5 px-4 text-center  whitespace-break-spaces">{moment.utc(item?.crt_dt).format('YYYY.MM.DD')}</td>
                                                                </tr>
                                                            )
                                                        ))
                                                    }
                                                    {
                                                        getBoardData?.list?.map((item, i) => (
                                                            (
                                                                <tr className="border-b border-gray-200 cursor-pointer hover:bg-[#3FBAB11F]"
                                                                    key={item.board_seq}
                                                                    onClick={event => {
                                                                        event.preventDefault();
                                                                        setSelectedBoard(true);
                                                                        const items = {
                                                                            board_seq: item.board_seq,
                                                                            page: 1,
                                                                            limit: 10,
                                                                            searchTxt: ''
                                                                        };
                                                                        getBoardMutate(items);
                                                                    }}>
                                                                    <td className="py-5 text-center  whitespace-break-spaces ">{(i + limit * (page - 1) + 1)}</td>
                                                                    <td className="py-5 px-4 text-left  whitespace-break-spaces ">{item.subject}
                                                                    </td>
                                                                    <td className="py-5 px-4 text-center  whitespace-break-spaces ">{moment.utc(item?.crt_dt).format('YYYY.MM.DD')}</td>
                                                                </tr>
                                                            )
                                                        ))
                                                    }
                                                </>
                                                :
                                                <tr className="border-b border-gray-200">
                                                    <td colSpan="3"
                                                        className="text-center h-[200px]   font-[700] text-[14px]">공지사항
                                                        목록이 없습니다
                                                    </td>
                                                </tr>
                                        }

                                        </tbody>
                                    </table>
                                    <div className="sm:hidden">
                                        {
                                            getBoardData && getBoardData?.totalCount > 0 ?
                                                <>
                                                    {
                                                        getBoardData?.noticeList?.map((item, i) => (
                                                            (
                                                                <div
                                                                    className="border-b border-gray-200 py-4 px-4 cursor-pointer"
                                                                    key={item.board_seq}
                                                                    onClick={event => {
                                                                        event.preventDefault();
                                                                        setSelectedBoard(true);
                                                                        const items = {
                                                                            board_seq: item.board_seq,
                                                                            page: 1,
                                                                            limit: 10,
                                                                            searchTxt: ''
                                                                        };

                                                                        getBoardMutate(items);
                                                                    }}>
                                                                    <div
                                                                        className="text-sm whitespace-break-spaces">공지
                                                                    </div>
                                                                    <div
                                                                        className="text-lg font-medium whitespace-break-spaces">{item.subject}
                                                                    </div>
                                                                    <div
                                                                        className="text-sm text-gray-500 mt-2 whitespace-break-spaces">{moment.utc(item?.crt_dt).format('YYYY.MM.DD')}</div>
                                                                </div>
                                                            )
                                                        ))
                                                    }
                                                    {
                                                        getBoardData?.list?.map((item, i) => (
                                                            (
                                                                <div
                                                                    // role="button"
                                                                    className="border-b border-gray-200 py-4 px-4 cursor-pointer"
                                                                    key={item.board_seq}
                                                                    onClick={event => {
                                                                        event.preventDefault();
                                                                        setSelectedBoard(true);
                                                                        const items = {
                                                                            board_seq: item.board_seq,
                                                                            page: 1,
                                                                            limit: 10,
                                                                            searchTxt: ''
                                                                        };
                                                                        getBoardMutate(items);
                                                                    }}>
                                                                    <div
                                                                        className="text-sm whitespace-break-spaces">{(i + limit * (page - 1) + 1)}</div>
                                                                    <div
                                                                        className="text-lg font-medium whitespace-break-spaces">{item.subject}
                                                                    </div>
                                                                    <div
                                                                        className="text-sm text-gray-500 mt-2 whitespace-break-spaces">{moment.utc(item?.crt_dt).format('YYYY.MM.DD')}</div>
                                                                </div>
                                                            )
                                                        ))
                                                    }
                                                </>
                                                :
                                                <div className="border-b border-gray-200">
                                                        <span
                                                            className="text-center py-28  block  font-[700] text-[18px]">공지사항
                                                            목록이 없습니다
                                                        </span>
                                                </div>
                                        }

                                    </div>
                                </div>
                            </div>
                            <div
                                className="md:mb-[200px] mb-[80px] mt-7 flex flex-col items-center justify-between text-xs text-gray-400">
                                <Pagination
                                    prevPageText={(<img src="/assets/prev.svg"/>)}
                                    nextPageText={(<img src="/assets/next.svg"/>)}
                                    activePage={page}
                                    itemsCountPerPage={limit}
                                    totalItemsCount={totalCount === 0 ? 1 : totalCount}
                                    pageRangeDisplayed={5}
                                    hideFirstLastPages={true}
                                    onChange={(e) => setPage(e)}
                                />

                                <div className="mt-7 flex items-center">
                                    <input
                                        className="md:w-[400px] w-[200px] h-10 px-4 bg-gray-100 rounded-[10px] placeholder:text-[#202020]"
                                        type="text" placeholder="검색어를 입력해주세요." onKeyDown={(e) => {
                                        if (e.key === 'Enter' && e.nativeEvent.isComposing === false) {
                                            if (e.target.value.length > 0 && e.target.value.trim().length === 0) {
                                                alert('직원을 입력해 주세요');
                                                setSearchValue(e.target.value.trim());
                                                return;
                                            }
                                            setSearchValue(e.target.value.trim());
                                            setSearchTxt(e.target.value);
                                            setPage(1);
                                        }
                                    }} value={searchValue} onChange={(e) => {
                                        setSearchValue(e.target.value);
                                    }}
                                    />
                                    <img className="md:ml-[-36px] ml-[-24px]" src="./assets/search.svg"/>
                                </div>
                            </div>
                        </>
                }

            </div>
        </main>
    );
};

export default Notice;
